'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {IndicatorsListCtrl} from "./indicatorslistctrl.js";
EwSiteApp.controller('IndicatorsListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", "$mdDialog", IndicatorsListCtrl]);